import Decimal from "decimal.js";

// Envio dos eventos de marketing. Os scripts da loja (GTM, Pixel) chegam pelo
// appScriptHead/appScriptBody que a function ssr injeta; aqui só falamos com
// o que eles deixam no window. Quem decide quando disparar são os thunks de
// ducks/tracking.js.
//
// Uma fonte por destino: eventos do Meta saem daqui pelo `fbq`, e o GTM
// recebe o funil pelo dataLayer para as tags do Google. Loja que criar tags
// do Meta também no GTM conta em dobro.

export const CURRENCY = "BRL";

/**
 * Empurra um evento no dataLayer no formato de e-commerce do GA4. O
 * `{ ecommerce: null }` antes é obrigatório numa SPA: o GTM faz merge
 * recursivo do dataLayer, que aqui nunca reinicia, e os `items` de um evento
 * vazariam no seguinte.
 */
export function pushDataLayer(event, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  if (payload.ecommerce) {
    window.dataLayer.push({ ecommerce: null });
  }
  window.dataLayer.push({ event, ...payload });
}

/**
 * `eventID` é o que a Meta usa para deduplicar com o mesmo evento enviado
 * pelo servidor (Conversions API).
 */
export function fbqTrack(name, params, eventID) {
  if (typeof window.fbq !== "function") return;
  if (eventID) {
    window.fbq("track", name, params, { eventID });
  } else {
    window.fbq("track", name, params);
  }
}

export const toNumber = (value) =>
  Number(
    Decimal(value || 0)
      .toDecimalPlaces(2)
      .toString(),
  );

/**
 * Um item no formato do GA4. `cost` é o total da linha (com adicionais e
 * quantidade), como no cachedCostPerOrder. O GA4 só aceita quantidade
 * inteira: produto por quilo vai como 1 unidade com o valor da linha.
 */
export function toTrackingItem({ product, qtt = 1, cost, groupName }) {
  const byWeight = !!product.isKilogram;
  const quantity = byWeight ? 1 : Math.max(1, Math.round(qtt));
  const lineCost = Decimal(cost ?? product.minPrice ?? 0);

  const item = {
    item_id: String(product.id),
    item_name: product.name,
    price: toNumber(lineCost.dividedBy(quantity)),
    quantity,
  };
  if (groupName) item.item_category = groupName;
  return item;
}

export const sumItems = (items) =>
  toNumber(
    items.reduce(
      (acc, item) => acc.plus(Decimal(item.price).times(item.quantity)),
      Decimal(0),
    ),
  );

/** Os mesmos itens no formato do Meta (`contents`/`content_ids`). */
export function toMetaContents(items) {
  return {
    content_ids: items.map((i) => i.item_id),
    content_type: "product",
    contents: items.map((i) => ({
      id: i.item_id,
      quantity: i.quantity,
      item_price: i.price,
    })),
    num_items: items.reduce((acc, i) => acc + i.quantity, 0),
  };
}
